/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1LocationStatesIdMutationResponse,
  DeleteApiV1LocationStatesIdPathParams,
  DeleteApiV1LocationStatesId401,
  DeleteApiV1LocationStatesId404,
  DeleteApiV1LocationStatesId409,
  DeleteApiV1LocationStatesId500,
} from "../../types/locationStateController/DeleteApiV1LocationStatesId.ts";

function getDeleteApiV1LocationStatesIdUrl(
  id: DeleteApiV1LocationStatesIdPathParams["id"],
) {
  const res = {
    method: "DELETE",
    url: `/api/v1/location/states/${id}` as const,
  };
  return res;
}

/**
 * @description Exclui um estado. Não é permitido excluir estados que possuam cidades vinculadas. **(Requer Authorization para autenticação)**
 * @summary Excluir estado (Requer Authorization para autenticação)
 * {@link /api/v1/location/states/:id}
 */
export async function deleteApiV1LocationStatesId(
  id: DeleteApiV1LocationStatesIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiV1LocationStatesIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1LocationStatesId401
      | DeleteApiV1LocationStatesId404
      | DeleteApiV1LocationStatesId409
      | DeleteApiV1LocationStatesId500
    >,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiV1LocationStatesIdUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
